export default {"src":"/_next/static/media/linkedin.f6b6e4b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};